import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/cilt-kurulugunda-mezoterapi-derin-nem-destegi-ve-hucresel-yenilenme/page.tsx");
